// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockTwoToneSvg from "@fishx/icons-svg/es/asn/UnlockTwoTone";
import FishxIcon from '../components/FishxIcon';

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockTwoToneSvg
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
export default React.forwardRef(UnlockTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UnlockTwoTone.js
// module id = 4309
// module chunks = 0